import PropTypes from 'prop-types';
import React from 'react';

import Slider from '../Slider';

import './index.scss';

const RepaymentTermSelector = ({ repaymentTerm, maximumRepaymentTerm, onRepaymentTermChange }) => {
  const minimumTerm = 1;

  const getRepaymentTermText = () => {
    if (repaymentTerm === 1) {
      return '1 year';
    } else {
      return `${repaymentTerm} years`;
    }
  };

  return (
    <div className="repayment-term-selector" data-testid="repayment-term-selector">
      <div className="repayment-term-selector__content">
        <h6>Length to repay</h6>
        <div className="repayment-term-selector__content__buttons">
          <button
            disabled={repaymentTerm <= minimumTerm}
            onClick={() => onRepaymentTermChange(repaymentTerm - 1)}
          >
            -
          </button>
          <h5>{getRepaymentTermText()}</h5>
          <button
            disabled={repaymentTerm >= maximumRepaymentTerm}
            onClick={() => onRepaymentTermChange(repaymentTerm + 1)}
          >
            +
          </button>
        </div>
      </div>
      <div className="repayment-term-selector__slider">
        <Slider
          minValue="1"
          maxValue={maximumRepaymentTerm}
          value={repaymentTerm}
          onValueChange={value => onRepaymentTermChange(value)}
        />
      </div>
    </div>
  );
};

RepaymentTermSelector.propTypes = {
  repaymentTerm: PropTypes.number.isRequired,
  maximumRepaymentTerm: PropTypes.number.isRequired,
  onRepaymentTermChange: PropTypes.func.isRequired,
};

export default RepaymentTermSelector;
